<input nbInput
       id="date"
       [(ngModel)]="value"
       fullWidth
       placeholder="Datum"
       [disabled]="isDisabled"
       [nbDatepicker]="datePicker">
<nb-datepicker #datePicker></nb-datepicker>
